/* @ngInject */
export default class {
  constructor($log, $location) {
    this.$log = $log;
    this.$location = $location;
  }

  validateEmail(email) {
    // returns true if valid email
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return (
      email &&
      regex.test(
        String(email)
          .trim()
          .toLowerCase()
      )
    );
  }

  validateUrl(str) {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$',
      'i'
    );
    return !!urlPattern.test(str);
  }

  validateDate(date) {
    const momentDate = moment(date, 'MM/DD/YYYY', true).isValid();

    return date && momentDate;
  }

  cleanDate(rawDate) {
    const date = moment.utc(rawDate);

    return (rawDate && date.isValid() ? date : moment.utc())
      .hour(8)
      .minute(0)
      .second(0)
      .millisecond(0)
      .toISOString();
  }

  getSubDomain() {
    try {
      const host = this.$location.host();
      if (host.indexOf('.') < 0) return 'localhost';
      else return host.split('.')[0];
    } catch (error) {
      this.$log.error(error);
      return 'localhost';
    }
  }

  getDomain() {
    try {
      const host = this.$location.host();
      if (host.indexOf('.') < 0) return 'localhost:8080';
      return host;
    } catch (error) {
      this.$log.error(error);
      return 'app.prolaera.com';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/HelperClass.js